import { render, staticRenderFns } from "./ListarFamilias.vue?vue&type=template&id=637d324d&"
import script from "./ListarFamilias.vue?vue&type=script&lang=js&"
export * from "./ListarFamilias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports